import $ from 'jquery';
import 'jquery-mask-plugin/dist/jquery.mask.min';

export const cepMask = (va) => {
  let value = String(va)
  if (value.length > 0) {
    return value
      .replace(/\D/g, "")
      .replace(/(\d{5})(\d{1,2})/, "$1-$2")
      .replace(/(-\d{3})\d+?$/, '$1')
  }
};


export const cpfMask = (va) => {
  let value = String(va);
  if (value.length > 0) {
    return value
      .replace(/\D/g, '')
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d{1,2})/, '$1-$2')
      .replace(/(-\d{2})\d+?$/, '$1');
  }
  return value;
};

export const cnpjMask = va => {
  let value = String(va)
  if (value.length > 0) {
    return value
      .replace(/\D/g, '')
      .replace(/(\d{2})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d)/, '$1/$2')
      .replace(/(\d{4})(\d{1,2})/, '$1-$2')
      .replace(/(-\d{2})\d+?$/, '$1')
  }
};

export const onlyNumber = va => {
  let value = String(va)
  if (value.length > 0) {
    return value
      .replace(/\D/g, '')
  }
}
export const onlyText = va => {
  let value = String(va)
  if (value.length > 0) {
    return value
      .replace(/[0-9]+$/gi, '')
  }
}


export const telephoneMask = (value) => {
  const digits = (value || '').toString().replace(/\D/g, '').slice(0, 8);

  return digits.replace(/(\d{4})(\d{0,4})/, (_, p1, p2) =>
    p2 ? `${p1}-${p2}` : p1
  );
};

export const celularMask = (value) => {
  const digits = (value || '').toString().replace(/\D/g, '').slice(0, 9);

  return digits.replace(/(\d{5})(\d{0,4})/, (_, p1, p2) =>
    p2 ? `${p1}-${p2}` : p1
  );
};


export const ClearMask = va => {
  if (va === null || va === undefined) {
    return "";
  }
  let value = String(va)
  if (value.length > 0) {
    return value
      .replace(" ", "")
      .replace('-', "")
      .replace("/", "")
      .replace('.', "")
  }
};

export const maskHour = (valor) => {

  let v = valor.replace(/\D/g, '');
  v = v.slice(0, 8);

  if (v.length >= 7) {
    return v.replace(/(\d{2})(\d{2})(\d{2})(\d{1,2})/, '$1:$2-$3:$4');
  } else if (v.length >= 5) {
    return v.replace(/(\d{2})(\d{2})(\d{1,2})/, '$1:$2-$3');
  } else if (v.length >= 3) {
    return v.replace(/(\d{2})(\d{1,2})/, '$1:$2');
  } else {
    return v;
  }
};


$(document).ready(() => { $('.cpf').mask('000.000.000-00') });
$(document).ready(() => { $('.cep').mask('00000-000') });
$(document).ready(() => { $('.telefone').mask('9 0000-0000') });
$(document).ready(() => { $('.certidao').mask("") })